import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  downloadCompanyBrands,
  getAdminBrandNames,
  updateBrandName,
} from '../../../api/admin';
import { useMutation } from '@tanstack/react-query';
import { Typography, Flex, Input, Select, message } from 'antd';
import { UserRequestsTable } from '../../../components/admin/brand-names';
import { BrandName, BrandNameStatus } from '../../../types';
import { format } from 'date-fns';

const { Option } = Select;


const UserRequestsTab: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);


  const handleUpdateBrandName = async (id: string, status: BrandNameStatus) => {
    try {
      // await updateBrandNameStatus({ id, status });  // TODO: add this
    } catch (error: any) {
      console.error(error);
      message.error(error.message || 'Failed to update brand name.');
    }
  };

  const { mutateAsync: downloadCompanyBrandsMutate } = useMutation({
    mutationFn: () =>
      downloadCompanyBrands({
        search: searchParams.get('search') || '',
      }),
    onError: (error: any) => {
      console.log(error);
      message.error(
        error.message || 'Company brands download failed. Please try again.',
      );
    },
  });

  const handleDownloadTable = async () => {
    try {
      const { file: base64Response } = await downloadCompanyBrandsMutate(); // TODO: change to downloadUserRequests

      if (!base64Response || typeof base64Response !== 'string') {
        throw new Error('Invalid file data');
      }

      const csvContent = atob(base64Response);
      const blob = new Blob([csvContent], { type: 'text/csv' });

      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `user_requests_${new Date().toISOString()}.csv`;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);

      message.success('File downloaded successfully');
    } catch (error: any) {
      console.error(error);
      message.error(error.message || 'Failed to download file.');
    }
  };

const columns = [
  {
    title: 'Full Name',
    dataIndex: 'fullName',
    key: 'fullName',
  },
  {
    title: 'Role',
    dataIndex: 'role',
    key: 'role',
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    render: (status: BrandNameStatus, record: BrandName) => { // TODO: change to UserRequest type
      return (
        <Select
          key={record.id}
          className="table-selector-select"
          style={{ width: 170, borderRadius: 4 }}
          defaultValue={status}
          size="small"
          onChange={async (status) => {
            // await handleUpdateBrandName(record.id, status); //TODO: add this
          }}
          optionLabelProp="label"
        >
          <Option
            value={BrandNameStatus.APPROVED}
            label={
              <Flex gap={8} align="center" style={{ paddingLeft: 8 }}>
                <span
                  style={{
                    display: 'inline-block',
                    width: 6,
                    height: 6,
                    borderRadius: '50%',
                    backgroundColor: '#1C8271',
                    marginRight: 8,
                    verticalAlign: 'middle',
                  }}
                />
                <Typography.Text>Approved</Typography.Text>
              </Flex>
            }
          >
            <Typography.Text>
              <span
                style={{
                  display: 'inline-block',
                  width: 6,
                  height: 6,
                  borderRadius: '50%',
                  backgroundColor: '#1C8271',
                  marginRight: 8,
                  verticalAlign: 'middle',
                }}
              />
              Approved
            </Typography.Text>
          </Option>
          <Option
            value={BrandNameStatus.PENDING}
            label={
              <Flex gap={8} align="center" style={{ paddingLeft: 8 }}>
                <span
                  style={{
                    display: 'inline-block',
                    width: 6,
                    height: 6,
                    borderRadius: '50%',
                    backgroundColor: '#FFA500',
                    marginRight: 8,
                    verticalAlign: 'middle',
                  }}
                />
                <Typography.Text>Pending</Typography.Text>
              </Flex>
            }
          >
            <Typography.Text>
              <span
                style={{
                  display: 'inline-block',
                  width: 6,
                  height: 6,
                  borderRadius: '50%',
                  backgroundColor: '#FFA500',
                  marginRight: 8,
                  verticalAlign: 'middle',
                }}
              />
              Pending
            </Typography.Text>
          </Option>
          <Option
            value={BrandNameStatus.REJECTED}
            label={
              <Flex gap={8} align="center" style={{ paddingLeft: 8 }}>
                <span
                  style={{
                    display: 'inline-block',
                    width: 6,
                    height: 6,
                    borderRadius: '50%',
                    backgroundColor: '#F68B8B',
                    marginRight: 8,
                    verticalAlign: 'middle',
                  }}
                />
                <Typography.Text>Rejected</Typography.Text>
              </Flex>
            }
          >
            <Typography.Text>
              <span
                style={{
                  display: 'inline-block',
                  width: 6,
                  height: 6,
                  borderRadius: '50%',
                  backgroundColor: '#F68B8B',
                  marginRight: 8,
                  verticalAlign: 'middle',
                }}
              />
              Rejected
            </Typography.Text>
          </Option>
        </Select>
      );
    },
  },
  {
    title: "Sender's Email",
    dataIndex: 'email',
    key: 'email',
  },
  {
    title: 'Date Submitted',
    dataIndex: 'dateSubmitted',
    key: 'dateSubmitted',
    render: (date: string) => (
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <Typography.Text>
          {format(new Date(date), 'd MMM, yyyy, h:mm a')}
        </Typography.Text>
      </div>
    ),
  },
];

  return (
    <>
      <UserRequestsTable
        data={[
          // TODO: add data
        ]}
        total={0}
        columns={columns}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        // TODO: add download data
      />
    </>
  );
};

export default UserRequestsTab;
